const header = document.querySelector('.header-wrapper');
const productMediaWrapper = document.querySelector('.product__media-wrapper');
const productInfoWrapper = document.querySelector('.product__info-wrapper');

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) {
      productMediaWrapper.classList.add('fixed-img');
      productInfoWrapper.classList.add('margin-content');
    } else {
      productMediaWrapper.classList.remove('fixed-img');
      productInfoWrapper.classList.remove('margin-content');
    }
  });
}, { threshold: 0.1 }); 

observer.observe(header);

